import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('boundariesGrid');

    return {
        LAST_ACTIVITY: t('lastActivity'),
        LAST_EDITED: t('lastEdited'),
        LOADING: t('loading'),
        NAME: t('name'),
        NO_BOUNDARIES: t('noBoundaries'),
        NO_MORE_BOUNDARIES: t('noMoreBoundaries')
    };
};

export default useTranslation;
